/**
 * @generated SignedSource<<01b1ac997b06e55084f41fdb743fed7c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ShippingDetailsQuotesTableRow_item$data = {
  readonly address: {
    readonly itemAddress: string | null;
  } | null;
  readonly " $fragmentType": "ShippingDetailsQuotesTableRow_item";
};
export type ShippingDetailsQuotesTableRow_item$key = {
  readonly " $data"?: ShippingDetailsQuotesTableRow_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"ShippingDetailsQuotesTableRow_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ShippingDetailsQuotesTableRow_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Address",
      "kind": "LinkedField",
      "name": "address",
      "plural": false,
      "selections": [
        {
          "alias": "itemAddress",
          "args": [
            {
              "kind": "Literal",
              "name": "fullCountryName",
              "value": true
            }
          ],
          "kind": "ScalarField",
          "name": "displayCityStateCountry",
          "storageKey": "displayCityStateCountry(fullCountryName:true)"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "680840e8f4be2057cc2db5bb156b5380";

export default node;
